import api from './authService';
import { CommercialDashboard, CommercialDashboardFilters } from '../utils/commercialDashboard';

const commercialDashboardService = {
  async getDashboard(filters: CommercialDashboardFilters): Promise<CommercialDashboard> {
    const response = await api.get<CommercialDashboard>('/sales/dashboard', {
      params: {
        period: filters.period || undefined,
        client_id: filters.client_id ?? undefined,
        project_type: filters.project_type || undefined,
        owner_id: filters.owner_id ?? undefined,
      },
    });
    return response.data;
  },
};

export default commercialDashboardService;
